import { ExternalLinkIcon, StackIcon } from '@radix-ui/react-icons';
import { Button, Flex, Heading, Text } from '@radix-ui/themes';
import env from 'config';
import { Controller } from 'lib_ts/enums/routing/controllers';
import { PlatformConsoleRoutes } from 'lib_ts/enums/routing/routes/platform-console';

/**
 * Bull Board lives on the node server (behind the same Trajekt-staff gate as the
 * Platform Console) and is opened in a new tab. In prod the app and API share an
 * origin (server_url = https://<host>/node), so the auth cookie is sent
 * automatically and access is re-validated server-side.
 */
const bullBoardUrl = `${env.server_url}/${Controller.PlatformConsole}/${PlatformConsoleRoutes.BullBoard}`;

export const JobsSection = () => {
  return (
    <Flex direction="column" align="center" justify="center" gap="4" py="9">
      <Flex
        align="center"
        justify="center"
        style={{
          width: '56px',
          height: '56px',
          borderRadius: 'var(--radius-4)',
          backgroundColor: 'var(--indigo-a3)',
          color: 'var(--indigo-11)',
        }}
      >
        <StackIcon width="28" height="28" />
      </Flex>

      <Flex direction="column" align="center" gap="1">
        <Heading size="5">Jobs</Heading>
        <Text color="gray" align="center" style={{ maxWidth: '420px' }}>
          Inspect job queues and retry failed jobs in Bull Board.
        </Text>
      </Flex>

      <Button
        size="2"
        onClick={() => window.open(bullBoardUrl, '_blank', 'noopener')}
      >
        <ExternalLinkIcon />
        Open Bull Board
      </Button>
    </Flex>
  );
};
